import React, { Component } from "react";
import {Link} from "react-router-dom";

import './ScheduledRoutes.scss';
import MyContext from '../MyContext.jsx';


class ScheduledRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      today_schedules : [],
      approved_schedules : [],
      pending_schedules : [],
      upcoming_schedules : []
    }
  }
  getExeScheduleRoutes(){
    var obj_this = this;

    const url = `${process.env.REACT_APP_SSS}/api/getExeScheduleRequests`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        const today_schedules = return_data.schedules.filter((item) => item.date == new Date().toLocaleDateString('en-CA'));
        const approved_schedules = today_schedules.filter((item) => item.status == 'APR');
        const pending_schedules = today_schedules.filter((item) => item.status == 'REQ');
        const upcoming_schedules = return_data.schedules.filter((item) => item.date > new Date().toLocaleDateString('en-CA'));
        obj_this.setState({
          today_schedules: today_schedules,
          upcoming_schedules: upcoming_schedules,
          approved_schedules: approved_schedules,
          pending_schedules: pending_schedules,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        // obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      // obj_this.props.history.replace("/");
    });
  }

  componentDidMount(){  
    this.context.setLocation({
      latitude : '',
      longitude : ''
    });  
    var obj_this = this;

    obj_this.getExeScheduleRoutes();
   
    $(".schedules_routes_page_container").on("click",".delete_schedule_button",function(){
      if(!confirm("Are you sure you want to delete")){
        return;
      }
      const schedule_id = $(this).attr("schedule_id");
      const url = `${process.env.REACT_APP_SSS}/api/deleteExeScheduleRequest`;
      obj_this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          schedule_id : schedule_id
        },
        type : "POST"
      }).done(function(return_data){
          // console.log(return_data);
        if(return_data.status == "success"){
          obj_this.getExeScheduleRoutes();
          alert("Schedule deleted")
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      });

    });


  
    ui.swipeMenu(".schedules_container");
  }
  
  render(){
    let statuses = {
      "APR" : {name : "APPROVED", color: 'green'},
      "REJ" : {name : "REJECTED", color: 'red'},
      "CNL" : {name : "CANCELLED", color: 'red'},
      "CLO" : {name : "CANCELLED", color: 'red'},
      "REQ" : {name : "REQUESTED", color: '#ff9b00'}
    }
  return (
    <MyContext.Consumer>
      {context => (
        <div className="schedules_routes_page_container noselect">
          <div className="header_spacer"></div>
          <div className="schedules_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Schedules</div>
              <Link className="new_schedule_button" to="/schedules/routes/new"> 
                <i className="fa fa-plus"></i> New</Link>
            </div>
            <div className="toggles_container">
              <div className="list_1 toggles selected" menu="0">
                <i className="fa fa-calendar-alt order_status_icon"></i>
                <div className="order_status">{new Date().toLocaleDateString('en-GB')}</div>
                <div className="order_count">{this.state.today_schedules.length}</div>
              </div>
              <div className="list_2 toggles" menu="1">
                <i className="fa fa-clipboard-check order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Approved</div>
                <div className="order_count">{this.state.approved_schedules.length}</div>
              </div>
              <div className="list_3 toggles" menu="2">
                <i className="fas fa-suitcase order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Pending</div>
                <div className="order_count">{this.state.pending_schedules.length}</div>
              </div>
              <div className="list_4 toggles" menu="3">
                <i className="fab fa-hive order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Upcoming</div>
                <div className="order_count">{this.state.upcoming_schedules.length}</div>
              </div>
            </div>

            <div className="list_blocks_container">
              <div className="lists_container">
                {this.state.today_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-road"></i> {item.name}</div>
                      </div>
                      <div className="schedules_button_container">
                        <div className="check_in_button" style={{color:statuses[item.status].color}}
                            schedule_id = {item.route_request_id}
                          >{statuses[item.status].name??""}</div>
                      </div>
                      <div></div>
                    </div>
                  </div>

                ))}
              </div>
              <div className="lists_container">
                {this.state.approved_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-road"></i> {item.name}</div>
                      </div>
                      <div className="schedules_button_container">
                      {/* border:2px solid green; */}

                        <div className="check_in_button" style={{color:statuses[item.status].color}}
                          schedule_id = {item.route_request_id}
                        >{statuses[item.status].name??""}</div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.pending_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-road"></i> {item.name}</div>
                        </div>
                        <div className="schedules_button_container">
                          <div className="check_in_button" style={{color:statuses[item.status].color}}
                            schedule_id = {item.route_request_id}
                          >{statuses[item.status].name??""}</div>
                      </div>
                      <div> </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.upcoming_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-road"></i> {item.name}</div>
                      </div>
                      <div className="schedules_button_container">
                        <div className="check_in_button" style={{color:statuses[item.status].color}}
                          schedule_id = {item.route_request_id}
                        >{statuses[item.status].name??""}</div>
                      </div>

                      <div className="delete_schedule_button"
                        schedule_id = {item.route_request_id}
                        style={{alignSelf : "center"}}
                      >       
                        <i className="fas fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default ScheduledRoutes;
ScheduledRoutes.contextType = MyContext;
